<p-toast [key]="toastKey"></p-toast>
